
<div class="wrap">
  <div class="wrap__title">
    <app-card
      [title]="'block.sns.card.title' | translate"
      [noContent]="true"
    ></app-card>
  </div>
  <div class="wrap__section">
    <div class="aside-container">
      <div class="aside-container__character"></div>
      <div class="aside-container__content">お急ぎの方・注文メールが届かない方はLINEでお問い合わせください</div>
    </div>
  </div>
  <div class="wrap__section">
    <app-card
      borderTopLeftRadius="0px"
      [borderBottomLeftRadius]="!(media.isLtMdObservable | async) ? '0px' : undefined"
    >
      <div class="card-container">
        <div class="card-container__title">
          <p class="title">{{ 'block.sns.card.title.inner' | translate }}</p>
        </div>
        <div class="card-container__content">
          <a
            class="link"
            href="https://lin.ee/1pcxNl6"
          >
            <img
              class="link__img"
              src="https://scdn.line-apps.com/n/line_add_friends/btn/ja.png"
              alt="友だち追加"
            >
          </a>
          <div class="qr">
            <img
              class="qr__img"
              src="https://qr-official.line.me/sid/M/955leonc.png"
            >
          </div>
        </div>
      </div>
    </app-card>
  </div>
</div>
